export const AUTH_DOMAINS_NOT_EMPTY_ERROR =
  'Your auth domains list cannot be empty.'
export const AUTH_DOMAINS_WRONG_FORMAT =
  'One of your configured auth domains is not formatted properly.'

const isDomain = /\w+\.\w{2,}/

export function computeAuthdomainsErrors(
  authDomains: string | null,
  membersCanAutoJoin: boolean
): string {
  if (membersCanAutoJoin === false) {
    return ''
  }

  if (authDomains === null || authDomains.length === 0) {
    return AUTH_DOMAINS_NOT_EMPTY_ERROR
  }

  const wrongFormat = authDomains.split(',').find((domain: string) => {
    return domain.length === 0 || isDomain.test(domain) === false
  })

  if (wrongFormat) {
    return AUTH_DOMAINS_WRONG_FORMAT
  }

  return ''
}
